import React from 'react';
import styled from 'styled-components/macro';
import { NotificationChatData } from 'app/core/api/company/api-company.types';
import styledFuncs from 'app/styles/styledFuncs';
import IconLib from 'app/shared/components/icon/icon-lib';
import Icon from 'app/shared/components/icon/Icon';
import SharedRoutePath from 'app/shared/SharedRoutePath';
import { useHistory } from 'react-router-dom';
import { useReadNotification } from 'app/core/api/company/api-company';
import AppImage from 'app/shared/components/app-image/AppImage';
import { DefaultUserImg } from 'app/shared/components/misc';

const LinkButton = styled.a`
  margin: ${styledFuncs.pad(0.5)} 0;
  justify-content: start;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #eaeaea;
  display: block;
  margin: 10px !important;
  padding: 10px;
  color: black;
  b {
    font-size: 13px;
    font-weight: bold;
    display: block;
    color: black;
  }
  text {
    font-size: 10px;
    color: black;
  }
`;
const LinkRightIcon = styled(Icon).attrs({
  icon: IconLib.CHEVRON_RIGHT,
})`
  position: absolute;
  right: ${styledFuncs.pad(4)};
  margin-top: -75px;
`;

type Props = {
  data: NotificationChatData[];
};
export default function ChatInfo({ data }: Props): JSX.Element {
  const history = useHistory();
  const { request$: readNotification$ } = useReadNotification();

  const DirectTochat = (id: number) => {
    readNotification$(id).subscribe();
    history.push(`${SharedRoutePath.CHAT}/${id}`);
  };
  return (
    <>
      {data.map(val => (
        <LinkButton
          color="default"
          key={val.customerName}
          onClick={() => DirectTochat(val.id)}
        >
          <AppImage
            alt="profile image"
            src={val.userProfilePhoto}
            fallbackImgNode={<DefaultUserImg size={60} />}
            height="60px"
            noPad
            className="mb-1.5 w-10 h-10 rounded"
          />
          <LinkRightIcon size={30} />
          <div style={{ marginLeft: '105px', marginTop: '-100px' }}>
            <b style={{ fontWeight: 600 }}>{val.customerName}</b>
            <text>{val.productName}</text>
            <br />
            <text>{val.date}</text>
            <br />
            <text>{val.time}</text>
          </div>
        </LinkButton>
      ))}
    </>
  );
}
